import ActivityItem from './ActivityItemOwner';
import { useTranslation } from 'react-i18next';

const RecentActivityCard = ({ activities }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-1">
      <div className="p-4 md:p-6 border-b border-border">
        <h3 className="text-lg md:text-xl font-black uppercase tracking-tighter text-foreground">
          {t('home_dipendente.activities_title')}
        </h3>
        <p className="text-[10px] md:text-xs font-medium uppercase tracking-widest text-muted-foreground mt-1">
          {t('home_dipendente.activities_subtitle')}
        </p>
      </div>
      <div className="divide-y divide-border">
        {activities?.length > 0 ? (
          activities?.map((activity) => (
            <ActivityItem key={activity?.id} activity={activity} />
          ))
        ) : (
          <div className="p-8 text-center">
            <p className="text-sm text-muted-foreground">
              {t('home_dipendente.no_activities')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivityCard;